export type SupportedLocale = 'de' | 'en'

export const SUPPORTED_LOCALES: SupportedLocale[] = ['de', 'en']

export const DEFAULT_LOCALE: SupportedLocale = 'de'

export interface I18nConfig {
  locale: SupportedLocale
  fallbackLocale: SupportedLocale
}
